/**
 * @generated SignedSource<<4852a50fb77de7cfb3bdc68ab193c6b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type helpObjectRequestForm_HelpObjectStoreRequestForm$data = {
  readonly description: string | null | undefined;
  readonly displayLink: string | null | undefined;
  readonly entityKey: string | null | undefined;
  readonly icon: {
    readonly iconUrl: AGG$URL;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "helpObjectRequestForm_HelpObjectStoreRequestForm";
};
export type helpObjectRequestForm_HelpObjectStoreRequestForm$key = {
  readonly " $data"?: helpObjectRequestForm_HelpObjectStoreRequestForm$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectRequestForm_HelpObjectStoreRequestForm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "helpObjectRequestForm_HelpObjectStoreRequestForm",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "concreteType": "HelpObjectStoreIcon",
      "kind": "LinkedField",
      "name": "icon",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "displayLink"
    },
    {
      "kind": "ScalarField",
      "name": "entityKey"
    }
  ],
  "type": "HelpObjectStoreRequestForm"
};

(node as any).hash = "b6f77b7f885b80c7c089b12ee6a15b78";

export default node;
